import React, {useState, useEffect} from 'react'
import {injectShopContainer} from '../react/ShopDataContainer'
import CartContainer, {injectCartContainer} from '../react/CartContainer'
import calcItemPriceArray from '../react/calcItemPriceArray'
import {Link} from 'react-router-dom';


// sushidon: free Crispy Rice w/Spicy Tuna with a $10+ (before tax) order
const CRISPY_RICE_SHOP_ID = 'sushidon'
const CRISPY_RICE_PROMO_CODE = 'crispydon26'
const CRISPY_RICE_PRODUCT_ID = 'HozJvhNQmSBrC2bOg5KX'
const CRISPY_RICE_MINIMUM = 10
// fixed cart-line id, so the free item can never be added twice
const CRISPY_RICE_CART_ID = 'free-crispy-rice-promo'

function findMenuProduct (shop, productId) {
  const subMenus = (shop && shop.subMenus) || []
  for (let i = 0; i < subMenus.length; i++) {
    const products = subMenus[i].products || []
    const match = products.find((product) => product.id === productId)
    if (match) { return match }
  }
  return null
}

function PromoCode ({cart, shop}) {
  const {discount} = cart.getSubtotals()
  function promoCodeChanged (e) {
    const code = String(e.target.value || '')
    cart.setPromoCode(code)
  }

  const products = cart.state.products || []
  const freeCrispyRice = products.find((product) => product.id === CRISPY_RICE_CART_ID)

  // keep the free crispy rice in sync with the code + the $10 minimum
  useEffect(() => {
    if (shop.shopId !== CRISPY_RICE_SHOP_ID) { return }

    const codeMatches =
      String(cart.state.promoCode || '').trim().toLowerCase() === CRISPY_RICE_PROMO_CODE
    // the minimum is on everything else in the cart, not the free item
    const qualifyingTotal = products.reduce((total, product) => {
      if (product.id === CRISPY_RICE_CART_ID) { return total }
      return total + (Number(calcItemPriceArray(product).totalPrice) || 0)
    }, 0)
    const qualifies = codeMatches && (qualifyingTotal >= CRISPY_RICE_MINIMUM)

    if (qualifies && !freeCrispyRice) {
      const product = findMenuProduct(shop, CRISPY_RICE_PRODUCT_ID)
      if (!product) { return }
      cart.addProduct(Object.assign({}, product, {
        id: CRISPY_RICE_CART_ID,
        productId: product.id,
        quantity: 1,
        price: '0.00',
        note: 'FREE — promo CrispyDon26',
      }))
    }
    if (!qualifies && freeCrispyRice) {
      cart.removeFromCart(CRISPY_RICE_CART_ID)
    }
  }, [cart.state.products, cart.state.promoCode, shop])

  // console.log('promo? shop', shop)
  if (['pablitostacoscorona','verdugopizza','pablitostacosvannuys','pablitosworld','kokorollpa','kluckinsd','lancers','cravestudiocity','pablitostacosnoho', 'pablitospizza', 'tanghuo', 'wokbar', 'pablitostacosburbank','pablitostacosoaks', 'seorae', 'themelt', 'mikaza', 'beachwood', 'inthemix', 'cravesunset', 'sushidon'].indexOf(shop.shopId) === -1) { return null}
  const isBeachwood = ['beachwood'].indexOf(shop.shopId) !== -1
  return(
    <div className="promo-code">
      <label htmlFor="promo-code-input">Promo/Gift Code:</label>
      <input
        value={cart.state.promoCode}
        onChange={promoCodeChanged}
        id="promo-code-input" type="text"/>
      {(discount > 0.5) ? <div className="applied">discount: ${discount}</div> : null}
      {freeCrispyRice ? <div className="applied">✓ Free Crispy Rice w/Spicy Tuna added</div> : null}
      {(isBeachwood && (['llama','bestpizza'].indexOf((cart.state.promoCode || '').toLowerCase()) !== -1) ) ?  <div 
      >
        <Link className="hidden-link" to="/products/PN262LCu1vnDbiY2cNQ1">🍕Add Free Pizza🍕</Link>
      </div> : null  }

    </div>
  )
}

const injectedPromoCode = injectShopContainer(injectCartContainer(PromoCode))

export default injectedPromoCode
